import React, {MouseEventHandler, useState} from 'react';
import { CANCEL } from '../ISRConstants';
import DeltaSwitch from 'Components/GMS/Products/ProductView/DeltaSwitch';
import {BackArrowIcon, EditIcon} from 'assests/GmsIcons';
import { useHistory } from 'react-router-dom';
import { promoteISR } from '../Pages/DefineModel/ModelServices/ModalServices';
import { toast } from 'react-toastify';
import PopUp from "../UI-Model/components/PopUp/PopUp";
import PromotionUIModel from "../UI-Model/components/PopUp/PromotionUIModel";

type TMainPageHeaderProps = {
    componentId: string;
    isrName: string;
    showLoader: boolean;
    loaderMessage?: string;
    productId?: string | null | undefined;
    id?: string | null | undefined;
    onEditClick?: MouseEventHandler<HTMLButtonElement> | undefined;
    isGuideDetail?: boolean;
}

const MainPageHeader = ({componentId, isrName, showLoader, loaderMessage, productId, id, onEditClick, isGuideDetail}: TMainPageHeaderProps) => {
    const history = useHistory();
    const [disable, setDisable] = useState<boolean>(false);
    const [showPromotionDialog, setShowPromotionDialog] = useState<boolean>(false);

    const path = isGuideDetail ? `/gms/guide/` : `/gms/isr`;

    const createPromotion = async (ids: string[]) => {
        if (productId === '') {
            toast.error('ProductId is required');
            return;
        }
        try {
            setDisable(true);
            toast.info('Promotion started ...');
            const response = await promoteISR(productId ? productId : id ?? '', ids);
            if (response?.done) {
                toast.success(response?.message);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.log("createPromotion ~ error:", error)
        } finally {
            setDisable(false);
        }
    }

    return (
        <React.Fragment>
            <div id={componentId} className={`tw-flex tw-py-1.5 tw-items-center tw-bg-shades-of-grey-10`}>
                <div id={`${componentId}-left-section`} className='tw-flex tw-items-center'>
                    <div id={`${componentId}-back-btn`} className='tw-flex tw-pe-4' onClick={() => history.replace(path)}>
                        <BackArrowIcon/>
                    </div>
                    <label id={`${componentId}-name`} className={`tw-text-black tw-text-[24px] tw-font-semibold`}>
                        {isrName ?? ''}
                    </label>
                </div>
                <button 
                    id={`${componentId}-edit-btn`}
                    onClick={onEditClick} 
                    className='tw-items-center tw-ml-4 tw-mt-1'
                >
                    <EditIcon />
                </button>
                <div className='tw-flex-1'/>
                <div id={`${componentId}-actions`} className='tw-flex tw-gap-2 tw-item-center tw-justify-end'>
                    {showLoader ? 
                        <label id={`${componentId}-loader-msg`} className='tw-text-[#747593] tw-text-sm tw-text-center tw-mt-2.5'>
                            {`${loaderMessage}`}
                        </label> 
                    : null}
                    <DeltaSwitch 
                        id={`${componentId}-status-switch`}
                        labels={['Live', 'Draft', 'Rollback']}
                    />
                    <button 
                        id={`${componentId}-cancel-btn`}
                        onClick={() => history.replace('/gms/isr')} 
                        className='btn-outlined'
                    >
                        {CANCEL}
                    </button>
                    <button 
                        id={`${componentId}-promote-btn`}
                        onClick={() => setShowPromotionDialog(true)}
                        // onClick={() => createPromotion('')}
                        disabled={disable}
                        className='button-style'
                    >
                        {'Promote'}
                    </button>
                </div>
            </div>

            {showPromotionDialog ?
                <PopUp title={'Promote'} content={<PromotionUIModel projectId={productId ?? ''} projectName={isrName} onSuccess={(ids) => {
                    createPromotion(ids);
                    setShowPromotionDialog(false);
                }} onClose={() => setShowPromotionDialog(false)}/>}/>
            : null}

        </React.Fragment>
    );
}

export default MainPageHeader